import React from "react";
import { api } from "api";
import _ from "lodash";
import { Field, reduxForm } from "redux-form";
import { Link } from "react-router-dom";
import { validate, validators } from "validate-redux-form";
import { RenderCurrency } from "Utils/renderField/renderReadField";
import { renderSearchSelect, renderField } from "Utils/renderField/renderField";
import { ListadoAccion } from "Utils/ListadoAccion";
import { DetalleAccion } from "Utils/DetalleAccion";
import { icons } from "icons";
import LoadMask from "Utils/LoadMask/LoadMask";
import { useEffect } from "react";

import {
    formatoNombre,
    formatoExistencia,
    formatoAcciones,
    buscar,
    formatoProducto,
    formatoCodigo,
    formatoEquivalente1,
} from "Utils/CamposComunes";

import {
    formatoCantidadDespachada,
    formatoAccionDetalle,
} from "./camposDespacho";

const listaSucursales = [];

const Form = (props) => {
    const {
        loader_productos,
        data_productos,
        seleccionados,
        page_productos,
        ver_buscador,
        sucursal_origen,
        search_productos,
        loader,
    } = props;

    // bind
    const {
        handleSubmit,
        cambioBuscador,
        listarProductos,
        sortChangeProductos,
        agregar,
        buscarProductos,
        agregarPrimer,
        asignarCantidadDespachada,
        quitar,
    } = props;

    const llavesListado = [
        //formatoEquivalente1
        {
            nombre: "producto__codigo",
            sort: true,
            caption: "Codigo",
            format: formatoCodigo,
            align: "left",
            width: "160px",
        },
        {
            nombre: "producto__codigo_equivalente_1",
            sort: true,
            caption: "Equivalente 1",
            format: formatoEquivalente1,
            align: "left",
            width: "160px",
        },
        {
            nombre: "producto__nombre",
            sort: true,
            caption: "Nombre",
            format: formatoNombre,
            align: "left",
        },
        {
            nombre: "inventario",
            sort: false,
            caption: "Existencia",
            format: formatoExistencia,
            align: "right",
            width: "100px",
        },
        {
            nombre: "acciones",
            sort: false,
            caption: "Agregar",
            format: formatoAcciones({
                agregar,
                cambio_buscador: cambioBuscador,
            }),
            align: "center",
            width: "90px",
        },
    ];
    const llavesDetalle = [
        { caption: "Código", nombre: "codigo", format: formatoCodigo, align: "left", width: "160px" },
        { caption: "Nombre", nombre: "producto", format: formatoProducto },
        {
            width: "150px",
            caption: "Cantidad",
            nombre: "cantidad_despachada",
            format: formatoCantidadDespachada({ asignarCantidadDespachada }),
        },
        // { caption: "Acciones", nombre: "quitar", format: formatoAccionDetalle(props), align: "center", width: "90px" },
    ];
    const getSucursales = (search) => {
        return api
            .get("sucursales", { search, exluir_esta_sucursal: true })
            .catch(() => {})
            .then((data) => {
                data.results.forEach((item) => {
                    if (item.id === sucursal_origen.id) return;
                    if (!_.find(listaSucursales, { id: item.id }))
                        listaSucursales.push(item);
                });
                return { options: listaSucursales };
            });
    };

    useEffect(() => {
        listaSucursales.length = 0; // limpiar la lista de sucursales
        getSucursales(""); // llamar a la función que realiza la búsqueda de sucursales sin ningún término de búsqueda
    }, [sucursal_origen]);
    

    return (
        <form onSubmit={handleSubmit} className="row form">
            <LoadMask loading={loader} light blur radius>
                <div className="col-12 mb-3">
                    <div className="grid-container pt-2 pb-2 row">
                        <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                            <label>Sucursal origen</label>
                            {sucursal_origen && (
                                <input
                                    className={"form-control"}
                                    type="text"
                                    autocomplete="off"
                                    value={
                                        sucursal_origen.nombre
                                            ? sucursal_origen.nombre
                                            : ""
                                    }
                                    disabled
                                />
                            )}
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                            <label htmlFor="sucursal_destino">
                                Sucursal destino:
                            </label>
                            <div
                                className="d-flex flex-column pr-0"
                                style={{ maxWidth: "650px" }}
                            >
                                <Field
                                    name="sucursal_destino"
                                    component={renderSearchSelect}
                                    loadOptions={getSucursales}
                                    options={listaSucursales}
                                    labelKey="nombre"
                                    valueKey="id"
                                    className="form-control"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 form-group">
                            <label htmlFor="responsable_transporte">
                                Responsable de transporte:
                            </label>
                            <div
                                className="d-flex flex-column pr-0"
                                style={{ maxWidth: "650px" }}
                            >
                                <Field
                                    name="responsable_transporte"
                                    component={renderField}
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="slide-container row mt-2 mb-3">
                    <div className={`col-lg-12 col-md-12 form-activo `}>
                        <ListadoAccion
                            buscar={buscar({
                                buscar: buscarProductos,
                                search: search_productos,
                                agregarPrimer: agregarPrimer,
                            })}
                            loader={loader_productos}
                            llaves={llavesListado}
                            data={data_productos}
                            listar={listarProductos}
                            sortChange={sortChangeProductos}
                            titulo={
                                <div className="d-flex flex-column flex-lg-row">
                                    <span
                                        style={{
                                            fontSize: "15px",
                                            marginBottom: "0.5rem",
                                        }}
                                        className="align-self-end"
                                    >
                                        Listado de Productos
                                    </span>
                                </div>
                            }
                            page={page_productos}
                        />
                    </div>
                </div>
                <div
                    className="slide-container row mb-4"
                    style={{ margin: "0" }}
                >
                    <div className={`col-lg-12 col-md-12 form-activo`}>
                        <DetalleAccion
                            data={seleccionados}
                            titulo={"Lista de Productos a despachar"}
                            llaves={llavesDetalle}
                            loader={loader_productos}
                            quitar={quitar}
                            agregar={agregar}
                        />
                        <div className="backgr-naranja-degradado" style={{}}>
                            <div
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                    backgroundColor: "#FFF",
                                    marginTop: "15px",
                                    padding: "15px",
                                }}
                            >
                                <Link
                                    className="btn btn-tertiary mr-1"
                                    to={"/traslados"}
                                >
                                    <img src={icons.cancelar} alt="" />
                                    Cancelar
                                </Link>

                                <button
                                    className="btn btn-primary ml-1"
                                    type="submit"
                                    disabled={seleccionados.length <= 0}
                                >
                                    <i className="fa fa-check mr" />
                                    Finalizar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </LoadMask>
        </form>
    );
};

const CrearDespacho = reduxForm({
    // a unique name for the form
    form: "CrearDespacho",
    validate: (data) => {
        return validate(data, {
            sucursal_destino: validators.exists()("Campo requerido"),
        });
    },
})(Form);

export default CrearDespacho;
